import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Block Header',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          paddingTop: px(4),
          paddingBottom: px(4),
          paddingRight: px(20),
          paddingLeft: px(20),
          borderTopStyle: 'solid',
          borderTopWidth: px(1),
          borderTopColor: createRgbaColor('e6e6e6'),
          borderBottomStyle: 'solid',
          borderBottomWidth: px(1),
          borderBottomColor: createRgbaColor('e6e6e6'),
          borderRightStyle: 'solid',
          borderRightWidth: px(1),
          borderRightColor: createRgbaColor('e6e6e6'),
          borderLeftStyle: 'solid',
          borderLeftWidth: px(1),
          borderLeftColor: createRgbaColor('e6e6e6'),
          backgroundColor: createRgbaColor('fff'),
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
